module.exports = __webpack_public_path__ + "static/media/Certificate2.b09c1bae.png";